import BaseEntity from "@/core/misc/BaseEntity";
import Product    from "@/domains/Products/Product";
import Tender     from "@/domains/Tenders/Tender";
import Partner    from "@/domains/Partners/Partner";
import Person     from "@/domains/Persons/Person";
import Core       from "@/core/Core";
import Utils      from "@/core/utils/Utils";

/**
 * Запрос поставщика на участие в тендере.
 * Отправляется, когда разрешения на поставку по товару тендера у поставщика нет.
 */
export default class TenderParticipationRequest extends BaseEntity {
    /** К какому тендеру поставщик отправляет заявку, нужен для отправки сообщения.
     * Бековская тема какая-то. **/
    public tender: Tender

    /** Продукт на который поставщик хочет получить разрешение **/
    public product: Product

    /** Поставщик **/
    public partner: Partner

    /** Поставщик **/
    public sender: Person


    static fromTender(tender: Tender) {
        const result = new this();

        result.tender = tender;
        result.product = tender.product;

        result.partner = Core.currentPartner;
        result.sender = Core.currentUser;

        return result;
    }

	static fromServer(data: any, result = new TenderParticipationRequest()): TenderParticipationRequest {
		const tenderParticipationRequest = super.fromServer(data, result);

		if (Utils.isObject(data.tender)) {
			tenderParticipationRequest.tender = data.tender
		}
		if (Utils.isObject(data.partner)) {
			tenderParticipationRequest.partner = data.partner;
		}
		if (Utils.isObject(data.product)) {
			tenderParticipationRequest.product = data.product;
		}
		if (Utils.isObject(data.sender)) {
			tenderParticipationRequest.sender = Utils.hydrate(data.sender, Person.fromServer);
		}

		return tenderParticipationRequest;
	}

}
